import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, tap, throwError } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class LoginService {

  url = '/gebruiker/loginToken';
  sessionUrl = '/gebruiker/loginSession';
  activeSessionUrl = '/gebruiker/sessie';

  constructor(private http : HttpClient) { }

  tryLogin(username : string, password : string) : Observable<any>
  {
    var data = { email : username, password : password};

    return this.http.post<any>(this.url,data).pipe(
      tap(x => console.log(JSON.stringify( x))),
      catchError(this.handleError)
    );
  }

  doSessionLogin(username : string, password : string) : Observable<any>
  {
    var data = { email : username, password : password};

    return this.http.post<any>(this.sessionUrl,data).pipe(
      tap(x => console.log(JSON.stringify( x)))
    );
  }

  getActiveSession() : Observable<any>
  {
    return this.http.get(this.activeSessionUrl).pipe(
      tap(x => console.log(JSON.stringify(x))),
      catchError(this.handleError)
    )
  }

  private handleError(err : HttpErrorResponse){
    console.log(err);
    return throwError(()=>'');
  }
}
